import { Expose, Transform } from 'class-transformer';
import AddressFormError from 'errors/AddressFormError';
import { flattenListErrors } from 'errors/helpers';

export default class PracticeBaseError extends AddressFormError {
  cqc_location_id: string[] = []
  name: string[] = []
  @Transform(({ value }) => flattenListErrors(value)) email_for_inquiries: string[] = []
  @Transform(({ value }) => flattenListErrors(value)) email_for_notifications: string[] = []
  @Transform(({ value }) => flattenListErrors(value)) phone_for_inquiries: string[] = []
  @Transform(({ value }) => flattenListErrors(value)) phone_for_notifications: string[] = []
  start_time: string[] = []
  end_time: string[] = []
  lunch_break: string[] = []
  description: string[] = []
  default_dental_nurse_bonus_rate: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []

  // The CQC-prefilled fields, for pages that render no inputs for them
  get cqc_prefilled_errors(): string[] {
    return [...this.address_errors, ...this.name]
  }
}